<template>
  <span :class="['inline-block', isFocus ? 'text-black bg-white shadow' : 'text-gray-600']">
    <a href="javascript:" class="p-3 flex items-center" @click.stop="!isFetching && (isFocus = !isFocus)">
      <span class="mr-1 relative">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :class="['w-6 h-6 -my-1', {'invisible': isFetching}]">
          <path d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
        </svg>
        <rotating-cube v-if="isFetching" size="12" class="absolute inset-0 m-auto" />
      </span>
      <span :class="{'opacity-50': isFetching}">{{ langName }}</span>
    </a>
    <div v-show="isFocus" class="border-t border-gray-300 flex flex-col">
      <button class="p-3 hover:bg-gray-100" @click="setLang('zh-cn')">中文</button>
      <button class="p-3 hover:bg-gray-100" @click="setLang('en-us')">English</button>
    </div>
  </span>
</template>

<script>
  import {computed, ref, watch} from '@vue/composition-api'

  import useI18n from '@/composables/i18n'
  import RotatingCube from '@/components/rotating-cube.vue'

  const LANGS = [
    ['zh-cn', '中文'],
    ['en-us', 'English'],
  ]

  export default {
    name: 'LangSelector',

    components: {
      RotatingCube,
    },

    setup () {
      let isFocus = ref(false)

      watch(isFocus, value => {
        if (value) {
          function onClickDocument () {
            isFocus.value = false
            document.removeEventListener('click', onClickDocument)
          }
          document.addEventListener('click', onClickDocument)
        }
      })

      let {lang, fetchLang} = useI18n()
      let currentLang = ref(lang.value)
      let langName = computed(() => LANGS.find(([id]) => id === currentLang.value)[1])
      let isFetching = ref(false)

      async function setLang (langId) {
        const prevLang = currentLang.value
        currentLang.value = langId
        isFetching.value = true
        try {
          await fetchLang(langId)
          lang.value = langId
        } catch (e) {
          currentLang.value = prevLang
          console.error('[MelonAuth] Failed to set language.')
          console.error(e)
        }
        isFetching.value = false
      }

      return {
        isFocus,

        isFetching,
        langName,
        setLang,
      }
    },
  }
</script>
